import { defineComponent as _defineComponent } from 'vue'
import { normalizeStyle as _normalizeStyle, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, unref as _unref, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-3b4a02d8"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "color-block" }

import { Button } from 'ant-design-vue'


export default /*#__PURE__*/_defineComponent({
  __name: 'ColorButton',
  props: {
  color: {
    type: String,
    required: true,
  },
},
  setup(__props) {



return (_ctx: any,_cache: any) => {
  const _component_IconPlatte = _resolveComponent("IconPlatte")!

  return (_openBlock(), _createBlock(_unref(Button), { class: "color-btn" }, {
    default: _withCtx(() => [
      _createElementVNode("div", _hoisted_1, [
        _createElementVNode("div", {
          class: "content",
          style: _normalizeStyle({ backgroundColor: __props.color })
        }, null, 4)
      ]),
      _createVNode(_component_IconPlatte, { class: "color-btn-icon" })
    ]),
    _: 1
  }))
}
}

})